const Bono = () => import('js/pages/info-cards/bono/index.js')
const BonoOro = () => import('js/pages/info-cards/bono-oro/index.js')
const TransGC = () => import('js/pages/info-cards/transGC/index.js')
const Wawa = () => import('js/pages/info-cards/wawa/index.js')

export default [
  {
    path: '/bono',
    name: 'bono',
    component: Bono,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/bono-oro',
    name: 'bono-oro',
    component: BonoOro,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/trans-gc',
    name: 'trans-gc',
    component: TransGC,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/wawa',
    name: 'wawa',
    component: Wawa,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
]